import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../reducers";
import {
  sendMfaChallengeCode,
  confirmMfaChallenge,
} from "../../actions/login.action";
import { getRecaptchaVerifier } from "../../firebase/firebaseUtils";

interface MfaChallengeProps {
  onComplete: () => void;
}

export default function MfaChallenge({ onComplete }: MfaChallengeProps) {
  const storeDispatch = useDispatch();
  const mfa = useSelector((state: ReduxState) => state.login.mfa);
  const [otp, setOtp] = useState("");
  const [codeSent, setCodeSent] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if ((window as any).recaptchaVerifier) {
      (window as any).recaptchaVerifier.clear();
    }
    const verifier = getRecaptchaVerifier("mfa-challenge-recaptcha");
    (window as any).recaptchaVerifier = verifier;
    return () => {
      try { verifier.clear(); } catch (_) {}
      delete (window as any).recaptchaVerifier;
    };
  }, []);

  async function handleSendCode() {
    setSending(true);
    const vId = await sendMfaChallengeCode(storeDispatch);
    setSending(false);
    if (vId) setCodeSent(true);
  }

  async function handleVerify() {
    const success = await confirmMfaChallenge(mfa.verificationId, otp, storeDispatch);
    if (success) onComplete();
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h5 className="subheading fs-14 mb-4 text-center">
          Two-Factor Authentication Required
        </h5>
        <div id="mfa-challenge-recaptcha" />
        {!codeSent ? (
          <div>
            <p className="text-center secondary-color mb-4">
              A verification code will be sent to your phone
            </p>
            {mfa.error && (
              <div className="login-error-text text-center mb-3">{mfa.error}</div>
            )}
            <button
              className="btn btn2 d-block w-100"
              onClick={handleSendCode}
              disabled={sending}
            >
              {sending ? "Sending code..." : "Send Code"}
            </button>
          </div>
        ) : (
          <div>
            <p className="text-center secondary-color mb-4">
              A code has been sent to your phone
            </p>
            <div className="form-signin-label-group">
              <input
                type="text"
                className="form-control input-login"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              <label>OTP</label>
            </div>
            {mfa.error && (
              <div className="login-error-text text-center mb-3">{mfa.error}</div>
            )}
            <button
              className="btn btn2 d-block w-100"
              onClick={handleVerify}
              disabled={mfa.verifying || !otp}
            >
              {mfa.verifying ? "Verifying..." : "Verify"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
